import React, { useEffect, useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const initialValues = {
 };
 

const validationSchema = Yup.object({
 
});


const Create = () => {

    const { id } = useParams();
    const navigate = useNavigate();

    const { readDataById } = useEntityCrud('AnswerWeights/get');
    const { updateDate } = useEntityCrud("AnswerWeights/Update")

    useEffect((e) => {
         
        readDataById(id).then(({ data }) => {
             
            if (data.status)
                formik.setValues({
                    ...data.result,
                    "answerRank": data.result.answerRank + " ستاره  "
                });
        });
    }, []);

    const onSubmit = (values) => {
         
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            "answerRank": parseInt(values.answerRank.replace(" ستاره  ", "")),
            "andwerPoints": values.andwerPoints
        };
        updateDate({ ...postedData, id }).then(({ data }) => {
             
            if (data.status) {
                toast.success('به روزرسانی وزن امتیاز معیارسنجی با موفقیت انجام شد');
                return navigate('/surveyPoints');
            } else
                toast.error(data.message);
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/surveyPoints', { replace: true });
    }


    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ویرایش وزن امتیاز نظرسنجی  </div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;